import React, { Component } from 'react';
import FakeData from '../../fake-data';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";
import './ClubInt.css';
import { ItemPicker, Modal, ComboBox, TagView, PhonePicker, ConfirmModal } from '../../components/Common';
import { LocationPicker } from '../../components/Event';
import { ClubInvites } from '../../components/Teams';
import { CountryDropdown, RegionDropdown } from 'react-country-region-selector';
import { AddSportFollow } from '../../App';

export default class ClubInt extends Component {
    constructor(p) {
        super(p)
        this.state = {
            club: {
                name: "",
                level: "",
                id: null,
                hash: null,
                email: "",
                phone: "",
                land: "",
                website: "",
                location: "",
                address: "",
                suburb: "",
                postal: "",
                state: "",
                country: "",
                teams: [],
                sports: [],
                socials: [],
                established: "",
                manager: { id: null, name: "" },
                secretary: { id: null, name: "" },
                about: "",
                otherPeople: [],
                settings: []
            },
            yourRole: {
                role: ""
            },
            confirmee: {
                name: "",
                email: ""
            },
            othersVerifications: [],
            levels: ["Amatuer", "Professional", "Semi-Professional"],
            roles: ["Admin Secretary", "Captain", "Chairman", "CFO", "CEO", "Coach", "COO", "Managing Director", "Player", "Referee", "Receptionist ", "Score Keeper", "Staff Admin"],
            isAddingSports: false,
            isAddingTeams: false,
            canAddTeams: false,
            isAfterReg: false,
            phoneErr: false,
            landErr: false
        }
    }


    componentWillMount() {
        if (FakeData.getData("clubStore")) {
            const data = FakeData.getData("clubStore");
            this.state.club.name = data.name
            this.setState({
                club: this.state.club
            });
        }
    }

    save() {
        const club = this.state.club;
        const _teams = this.getTeamNames();
        if (club.name === "" || FakeData.inArray(this.state.club.name.toLowerCase(),_teams)) {
            this.setState({ nameErr: true });
            return;
        }

        if (club.level === "") {
            this.setState({ levelErr: true });
            return;
        }

        if (this.state.yourRole.role === "") {
            this.setState({ roleErr: true });
            return;
        }

        if (club.email === "" || !FakeData.isEmail(club.email)) {
            this.setState({ emailErr: true });
            return;
        }

        if (club.phone === "" || this.state.phoneErr) {
            this.setState({ phoneErr: true });
            return;
        }

        if (club.land === "" || this.state.landErr) {
            this.setState({ landErr: true });
            return;
        }

        if (club.website === "" || !FakeData.isWebsite(club.website)) {
            this.setState({ webErr: true });
            return;
        }

        if (club.address === "") {
            this.setState({ addressErr: true });
            return;
        }

        if (club.suburb === "") {
            this.setState({ suburbErr: true });
            return;
        }

        if (club.location === "") {
            this.setState({ locationErr: true });
            return;
        }

        if (club.postal === "") {
            this.setState({ postalErr: true });
            return;
        }

        if (club.country === "") {
            this.setState({ countryErr: true });
            return;
        }

        if (club.state === "") {
            this.setState({ stateErr: true });
            return;
        }

        if (club.sports.length === 0) {
            this.setState({ sportsErr: true });
            return;
        }

        if (club.teams.length === 0 && this.state.canAddTeams) {
            this.setState({ teamsErr: true });
            return;
        }

        if (club.manager.id === null) {
            this.setState({ managerErr: true });
            return;
        }

        if (club.secretary.id === null) {
            this.setState({ secretaryErr: true });
            return;
        }

        if (this.state.confirmee.name === "") {
            this.setState({ confirmeeNameErr: true });
            return;
        }

        if (this.state.confirmee.email === "" || !FakeData.isEmail(this.state.confirmee.email)) {
            this.setState({ confirmeeEmailErr: true });
            return;
        }

        const others = this.state.othersVerifications

        /*if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff") && (this.state.othersVerifications.length === 0)) {
            //console.log(this.state.yourRole.role, this.state.othersVerifications.length)
            this.setState({ needRoles: false });
        } else {
            this.setState({ needRoles: true });
            return;
        }*/

        let bool = false;
        for (let x = 0; x < others.length; x++) {
            let item = others[x];
            if (item.name === "") {
                item.nameError = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }

            if (item.email === "" || !FakeData.isEmail(item.email)) {
                item.emailErr = true;
                this.setState({ othersVerifications: others });
                bool = true;
            }
        }

        if (bool) {
            return;
        }

        const _that = this;

        club['username'] = club.name.replace(" ","_").toLowerCase();
        this.setState({ club: club });
        const dataTo = {
            club: club,
            confirmee: this.state.confirmee,
            role: this.state.yourRole,
            otherPeople: others,
            user: FakeData.getData("yoo")
        }

        //console.log(dataTo)
        FakeData.post("/createClub.php?auth0", dataTo, {
            success: ((res) => {
                if (res.error) {
                    FakeData.alert("A club with the email or name provided already exists!");
                    _that.setState({ emailErr: true });
                } else {
                    _that.state.club.id = res.id;
                    _that.state.club.hash = res.hash;
                    _that.setState({ isAfterReg: true, club: _that.state.club });
                }
            }),
            error: ((err) => {

            })
        }, true, "Club was created!", ((e) => { }))

    }

    getTeamNames = () => {
        const _teams = FakeData.getData("all_teams");
        const names = [];
        const rawNames = _teams.map((item, i)=>{
            return FakeData.nullify(item.rawName).toLowerCase();
        });

        const teamName = _teams.map((item, i)=>{
            return FakeData.nullify(item.name).split("(")[0].toLowerCase();
        });

        return names.concat(teamName, rawNames);
    }

    onSportsFollowAdd(arr) {
        this.state.club.sports = arr;
        this.setState({
            club: this.state.club,
            sportsErr: (arr.length === 0) ? true : false,
            isAddingSports: false
        });
    }

    onPhoneChange(num, err) {
        this.state.club.phone = num
        this.setState({ club: this.state.club, phoneErr: err });
    }

    onLandlineChange(num, err) {
        this.state.club.land = num
        this.setState({ club: this.state.club, landErr: err });
    }

    getSportsWithoutTeams() {
        const teams = this.state.club.teams;
        const sports = this.state.club.sports;
        const list = [];
        if (teams.length === 0) {
            return sports;
        }

        for (let i = 0; i < sports.length; i++) {
            const sport = sports[i];
            let found = false;
            for (let x = 0; x < teams.length; x++) {
                const team = teams[x];
                if (team.sport === sport.name) {
                    found = true;
                    break;
                }
            }

            if (!found) {
                list.push(sport)
            }
        }

        return list;
    }

    getSportByName(n) {
        const sports = this.state.club.sports;
        const list = [];
        for (let i = 0; i < sports.length; i++) {
            const sport = sports[i];
            if (sport.name === n) {
                list.push(sport);
                break;
            }
        }

        return list;
    }

    render() {
        const sports = this.getSportsWithoutTeams();
        const _teams = this.getTeamNames();
        return (
            <div className="full-screen-page">
                {!this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-register-profile-content">
                            <div className="after-register-profile-content-head">
                                <img src="images/add_blu.svg" />
                                <h1>Club Profile</h1>
                            </div>
                            <div className="after-register-profile-content-body">
                                <div className="register-profile-content-body-item">
                                    <h2>Club Details</h2>
                                    <div>
                                        <input placeholder="Club Name" className={(this.state.nameErr) ? "error" : FakeData.inArray(this.state.club.name.toLowerCase(),_teams)?"error": ""} value={this.state.club.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.club.name = val;
                                            this.setState({ club: this.state.club, nameErr:  FakeData.inArray(val.toLowerCase(),_teams)?true:false });
                                        }} />
                                        <select className={(this.state.levelErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.club.level = val;
                                            this.setState({ club: this.state.club, levelErr: false });
                                        }} value={this.state.club.level}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>Club professional level?</option>
                                            {
                                                this.state.levels.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <select className={(this.state.roleErr) ? "error" : ""} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.yourRole.role = val;
                                            this.setState({ yourRole: this.state.yourRole, roleErr: false });
                                        }} value={this.state.yourRole.role}>
                                            <option value="" disabled={true} style={{ padding: "10px" }}>What is your role in the club?</option>
                                            {
                                                this.state.roles.map((item, i) => {
                                                    return (
                                                        <option value={item} key={i} style={{ padding: "10px" }}>{item}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.emailErr) ? "error" : ""} placeholder="clubname@clubwebsite.com" value={this.state.club.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.email = val;
                                                this.setState({ club: this.state.club, emailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/mobile_icon_blu.svg" />
                                            <PhonePicker className={(this.state.phoneErr) ? "error" : ""} value={this.state.club.phone} onChange={this.onPhoneChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/landline_icon_blu.svg" />
                                            <PhonePicker className={(this.state.landErr) ? "error" : ""} value={this.state.club.land} onChange={this.onLandlineChange.bind(this)} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/website_icon_blu.svg" />
                                            <input className={(this.state.webErr) ? "error" : ""} placeholder="www.clubwebsite.com" value={this.state.club.website} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.website = val;
                                                this.setState({ club: this.state.club, webErr: !FakeData.isWebsite(val) });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="images/location_icon.svg" />
                                            <input className={(this.state.addressErr) ? "error" : ""} placeholder="Address" value={this.state.club.address} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.address = val;
                                                this.setState({ club: this.state.club, addressErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.suburbErr) ? "error" : ""} placeholder="Suburb" value={this.state.club.suburb} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.suburb = val;
                                                this.setState({ club: this.state.club, suburbErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input className={(this.state.locationErr) ? "error" : ""} placeholder="City" value={this.state.club.location} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.location = val;
                                                this.setState({ club: this.state.club, locationErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <input type="number" max="99999" className={(this.state.postalErr) ? "error" : ""} placeholder="Postal Code" value={this.state.club.postal} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.club.postal = val;
                                                this.setState({ club: this.state.club, postalErr: false });
                                            }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <CountryDropdown classes={(this.state.countryErr) ? "select-input error" : "select-input"}
                                                value={this.state.club.country}
                                                onChange={(val) => {
                                                    this.state.club.country = val;
                                                    this.setState({ club: this.state.club, countryErr: false });
                                                }} />
                                        </div>
                                        <div className="register-input">
                                            <img src="" />
                                            <RegionDropdown classes={(this.state.stateErr) ? "select-input error" : "select-input"}
                                                country={this.state.club.country}
                                                value={this.state.club.state}
                                                onChange={(val) => {
                                                    this.state.club.state = val;
                                                    this.setState({ club: this.state.club, stateErr: false });
                                                }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Add sports offered by this club</h2>
                                    <div className={(this.state.sportsErr) ? "added-sports-list error" : "added-sports-list"}>
                                        {
                                            this.state.club.sports.map((item, i) => {

                                                return (
                                                    <div key={i} className="added-sport-item">
                                                        <img src={(item.image === null) ? "" : item.image.replace("_wht", "")} />
                                                    </div>
                                                )
                                            })
                                        }
                                        <div className="add-to-sport" onClick={() => {
                                            this.setState({
                                                isAddingSports: true
                                            });
                                        }}>
                                            <img src="images/add_blu.svg" /> Add
                                    </div>
                                    </div>
                                    <h2>Add teams to this club</h2>
                                    {(this.state.club.sports.length === 0 && !this.state.canAddTeams) &&
                                        <div>
                                            Choose sports before you can add teams
                                    </div>
                                    }
                                    {(this.state.club.sports.length > 0 && !this.state.canAddTeams) &&
                                        <div>
                                            If you want add teams to your club, click <a style={{ fontWeight: "bold", cursor: "pointer" }} onClick={() => {
                                                this.setState({ canAddTeams: true });
                                            }}>here</a>, otherwise you can add them later!
                                    </div>
                                    }
                                    {(this.state.club.sports.length > 0 && this.state.canAddTeams) &&
                                        <div className={(this.state.teamsErr) ? "added-teams-list error" : "added-teams-list"}>
                                            {
                                                this.state.club.teams.map((item, i) => {

                                                    return (
                                                        <AddedTeamItem sports={this.getSportByName(item.sport)} delete={() => {
                                                            this.state.club.teams.splice(i, 1)
                                                            this.setState({ club: this.state.club });
                                                        }} save={(arr) => {
                                                            item: arr
                                                            this.setState({ club: this.state.club });
                                                        }} key={i} item={item} deleteKey={(key) => {
                                                            item[key].hide = true
                                                            this.setState({ club: this.state.club });
                                                        }} />
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    {(this.state.club.sports.length > 0 && this.state.canAddTeams) &&
                                        <div className={"added-sports-list"}>
                                            <div className="add-to-sport" onClick={() => {
                                                this.setState({
                                                    isAddingTeams: true
                                                });
                                            }}>
                                                <img src="images/add_blu.svg" /> Add
                                        </div>
                                            <div className="flexCenter" onClick={() => {
                                                this.setState({ canAddTeams: false, teamsErr: false });
                                            }}>or <a style={{ fontWeight: "bold", cursor: "pointer", marginLeft: "10px" }} >Add Later</a></div>
                                        </div>
                                    }
                                </div>
                                <div className="register-profile-content-body-item">
                                    <h2>Club Management</h2>
                                    <div>
                                        <ItemPicker label="Club Manager" user={FakeData.getData("yoo")} error={this.state.managerErr} onSelectedItem={(user) => {
                                            this.state.club.manager = user;
                                            this.setState({ club: this.state.club, managerErr: false });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                        <br />
                                        <ItemPicker label="Club Secretary" user={FakeData.getData("yoo")} error={this.state.secretaryErr} onSelectedItem={(user) => {
                                            this.state.club.secretary = user;
                                            this.setState({ club: this.state.club, secretaryErr: false });
                                        }} width="27.85em" isExtended={true} data={(FakeData.getData("yoo")) ? FakeData.getData("yoo").friends : []} />
                                    </div>
                                    <h2>Confirmation</h2>
                                    <div>
                                        <p>To Confirm that <b>{(this.state.club.name === "") ? "this club" : this.state.club.name}</b> does exist please enter at least one person’s name from one of the sports teams that make up the teams at the club.</p>
                                        <input className={(this.state.confirmeeNameErr) ? "error" : ""} placeholder="Name" value={this.state.confirmee.name} onChange={(e) => {
                                            const val = e.target.value
                                            this.state.confirmee.name = val;
                                            this.setState({ confirmee: this.state.confirmee, confirmeeNameErr: false });
                                        }} />
                                        <div className="register-input">
                                            <img src="images/email_icon_blu.svg" />
                                            <input className={(this.state.confirmeeEmailErr) ? "error" : ""} placeholder="name@example.com" value={this.state.confirmee.email} onChange={(e) => {
                                                const val = e.target.value
                                                this.state.confirmee.email = val;
                                                this.setState({ confirmee: this.state.confirmee, confirmeeEmailErr: !FakeData.isEmail(val) });
                                            }} />
                                        </div>
                                        <p className={this.state.needRoles ? "error" : ""}>If you have selected your role as <b>Club Manager, Coach, Referee or Score keeper</b> you will need to be verified by an additional person. This is important, non-verification of your role will mean you cannot create games or access the Game Management console (GMC).</p>
                                        <div>
                                            {
                                                this.state.othersVerifications.map((item, i) => {
                                                    return (
                                                        <div key={i} className="verify-input">
                                                            <input placeholder="Name" className={(item.nameError) ? "error" : ""} value={item.name} onChange={(e) => {
                                                                const val = e.target.value
                                                                item.name = val;
                                                                item.nameError = false
                                                                this.setState({ othersVerifications: this.state.othersVerifications });
                                                            }} />
                                                            <div className="register-input">
                                                                <img src="images/email_icon_blu.svg" />
                                                                <input className={(item.emailErr) ? "error" : ""} placeholder="name@example.com" value={item.email} onChange={(e) => {
                                                                    const val = e.target.value
                                                                    item.email = val;
                                                                    item.emailErr = !FakeData.isEmail(val)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }} />
                                                                <i className="material-icons" onClick={() => {
                                                                    this.state.othersVerifications.splice(i, 1)
                                                                    this.setState({ othersVerifications: this.state.othersVerifications });
                                                                }}>delete</i>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="profile_add_item_alt" onClick={() => {
                                            if ((this.state.yourRole.role === "Admin" || this.state.yourRole.role === "Staff" || this.state.yourRole.role === "")) {
                                                return;
                                            } else if ((this.state.othersVerifications[this.state.othersVerifications.length - 1] && (this.state.othersVerifications[this.state.othersVerifications.length - 1].name === "" || this.state.othersVerifications[this.state.othersVerifications.length - 1].email === ""))) {
                                                return
                                            }
                                            this.state.othersVerifications.push({ name: "", nameError: false, email: "", emailErr: false })
                                            this.setState({ othersVerifications: this.state.othersVerifications, needRoles: false });
                                        }}>Add a verification contact</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div tabIndex="0" className="after-register-profile-button gbl-btn" onClick={this.save.bind(this)}>Save Profile</div>
                    </div>
                }
                {this.state.isAfterReg &&
                    <div className="after-register-profile" style={{ width: "85%" }}>
                        <div className="after-reg">
                            <h3>Club page created successfully!</h3>
                            <Link  to={{ pathname: "/club/" + this.state.club.username, search: '?sInit=about' }}>Continue to Club Page</Link>
                        </div>
                    </div>
                }
                <AddSportFollow isOpen={this.state.isAddingSports} onClose={this.onSportsFollowAdd.bind(this)} />
                <AddTeamWithSquads isClub={true} sports={sports} isOpen={this.state.isAddingTeams} onClose={(arr) => {
                    if (arr === null) {
                        this.setState({
                            isAddingTeams: false
                        });
                    } else {
                        this.state.club.teams.push(arr)
                        this.setState({
                            isAddingTeams: false,
                            club: this.state.club
                        });
                    }

                }} />
            </div >
        );
    }
}

export class AddedTeamItem extends Component {
    constructor(p) {
        super(p)
        this.state = {
            isEditting: false
        }
    }

    render() {
        const item = this.props.item;
        return (
            <div className="added-teams-item">
                <h4>{item.sport}</h4>
                <div className="added-teams-chips">
                    {!item.male.hide &&
                        <div className="added-teams-chip">
                            <span>{item.male.designations.length}</span>
                            <span>Males</span>
                            <i className="material-icons" onClick={() => this.props.deleteKey("male")}>close</i>
                        </div>
                    }
                    {!item.female.hide &&
                        <div className="added-teams-chip">
                            <span>{item.female.designations.length}</span>
                            <span>Females</span>
                            <i className="material-icons" onClick={() => this.props.deleteKey("female")}>close</i>
                        </div>
                    }
                    {!item.mixed.hide &&
                        <div className="added-teams-chip">
                            <span>{item.mixed.designations.length}</span>
                            <span>Mixed</span>
                            <i className="material-icons" onClick={() => this.props.deleteKey("mixed")}>close</i>
                        </div>
                    }
                </div>
                <i className="material-icons" onClick={() => {
                    this.setState({ isEditting: true });
                }}>edit</i>
                <i className="material-icons" onClick={this.props.delete}>close</i>
                {this.state.isEditting &&
                    <AddTeamWithSquads data={item} sports={this.props.sports} isOpen={this.state.isEditting} onClose={(arr) => {
                        if (arr === null) {
                            this.setState({
                                isEditting: false
                            });
                        } else {
                            this.props.save(arr)
                            this.setState({
                                isEditting: false
                            });
                        }

                    }} />
                }
            </div>
        );
    }
}

export class AddTeamWithSquads extends Component {
    constructor(p) {
        super(p)
        this.state = {
            team: (this.props.data) ?
                this.props.data
                : {
                    male: {
                        ages: [],
                        designations: [],
                        assCoach: { name: "", id: null },
                        coach: { name: "", id: null },
                        hide: false
                    },
                    ground: "",
                    phone: "",
                    land: "",
                    website: "",
                    email: "",
                    level: "",
                    name: "",
                    role: "",
                    mixed: {
                        ages: [],
                        designations: [],
                        assCoach: { name: "", id: null },
                        coach: { name: "", id: null },
                        hide: false
                    },
                    female: {
                        ages: [],
                        designations: [],
                        assCoach: { name: "", id: null },
                        coach: { name: "", id: null },
                        hide: false
                    },
                    sport: "",
                    coaches: {
                        male: [{ name: "", id: null, teams: [], key: "male" }],
                        female: [{ name: "", id: null, teams: [], key: "female" }],
                        mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                    },
                    assCoaches: {
                        male: [{ name: "", id: null, teams: [], key: "male" }],
                        female: [{ name: "", id: null, teams: [], key: "female" }],
                        mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                    }
                },
            genders: ["Male", "Female", "Mixed"],
            currentView: "male",
            ageTarget: "Select Group",
            isSearching: false
        }

        this.removeTeamFromCoach = this.removeTeamFromCoach.bind(this)
        this.updateTeamsCoach = this.updateTeamsCoach.bind(this)
        this.removeTeamsCoach = this.removeTeamsCoach.bind(this)
    }

    getTeamNames = () => {
        const _teams = FakeData.getData("all_teams");
        const names = [];
        const rawNames = _teams.map((item, i)=>{
            return FakeData.nullify(item.rawName).toLowerCase();
        });

        const teamName = _teams.map((item, i)=>{
            return FakeData.nullify(item.name).split("(")[0].toLowerCase();
        });

        return names.concat(teamName, rawNames);
    }

    onClose() {
        if (this.props.requireExtraContent) {
            this.props.onClose(null, () => { })
        } else {
            this.props.onClose(null)
        }
        this.setState({
            team: {
                male: {
                    ages: [],
                    designations: [],
                    assCoach: { name: "", id: null },
                    coach: { name: "", id: null },
                    hide: false
                },
                ground: "",
                mixed: {
                    ages: [],
                    designations: [],
                    assCoach: { name: "", id: null },
                    coach: { name: "", id: null },
                    hide: false
                },
                female: {
                    ages: [],
                    designations: [],
                    assCoach: { name: "", id: null },
                    coach: { name: "", id: null },
                    hide: false
                },
                sport: "",
                coaches: {
                    male: [{ name: "", id: null, teams: [], key: "male" }],
                    female: [{ name: "", id: null, teams: [], key: "female" }],
                    mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                },
                assCoaches: {
                    male: [{ name: "", id: null, teams: [], key: "male" }],
                    female: [{ name: "", id: null, teams: [], key: "female" }],
                    mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                }
            }
        });
    }

    getAges() {
        const list = [];
        for (let x = 7; x < 19; x++) {
            list.push("Under " + x);
        }

        list.push("Seniors")
        list.push("Mixed")

        return list;
    }

    addToDesignation(age) {
        const nextDesgnation = this.checkAgeDesignations(age).length + 1;
        const _designation = {
            entry: nextDesgnation,
            age: age,
            name: "",
            gender: this.state.currentView,
            coach: { id: null, name: "" },
            assCoach: { id: null, name: "" },
            coachErr: false,
            assCoachErr: false
        }

        this.state.team[this.state.currentView].designations.push(_designation);
        this.setState({ team: this.state.team, teamsErr: false });
    }

    removeFromDesignation(age, also) {
        this.state.team[this.state.currentView].designations.forEach((item, i) => {
            if (item.age === age) {
                this.state.team[this.state.currentView].designations.splice(i, 1);
                this.setState({ team: this.state.team });
            }
        })

        this.state.team[this.state.currentView].ages.forEach((item, i) => {
            if (item === age) {
                this.state.team[this.state.currentView].ages.splice(i, 1);
                this.setState({ team: this.state.team });
            }
        })

        for (let i = 0; i < this.state.team.coaches[this.state.currentView].length; i++) {
            const coach = this.state.team.coaches[this.state.currentView][i];
            coach.teams.forEach((item, x) => {
                if (item.age === age && (item.gender === this.state.currentView)) {
                    this.state.team.coaches[this.state.currentView][i].teams.splice(x, 1);
                    this.setState({ team: this.state.team });
                }
            })
        }

        for (let i = 0; i < this.state.team.assCoaches[this.state.currentView].length; i++) {
            const coach = this.state.team.assCoaches[this.state.currentView][i];
            coach.teams.forEach((item, x) => {
                if (item.age === age && (item.gender === this.state.currentView)) {
                    this.state.team.assCoaches[this.state.currentView][i].teams.splice(x, 1);
                    this.setState({ team: this.state.team });
                }
            })
        }
    }

    checkAgeDesignations(age) {
        const newList = [];
        const currList = this.state.team[this.state.currentView].designations;
        currList.forEach((item, i) => {
            if (item.age === age) {
                newList.push(item)
            }
        })

        return newList;
    }

    addCoach(coach, coachIndex, team, key) {
        let bool = false;
        if (coach.key !== team.gender) {
            return;
        }
        this.state.team[key][this.state.currentView][coachIndex].teams.forEach((item, i) => {
            if (item.age === team.age && item.entry === team.entry && (item.gender === coach.key)) {
                this.state.team[key][this.state.currentView][coachIndex].teams.splice(i, 1);
                this.setState({ team: this.state.team });
                this.removeTeamCoach(team, (key === "coaches") ? "coach" : "assCoach")
                bool = true;
            }
        })

        if (!bool && team.gender === coach.key) {
            this.state.team[key][this.state.currentView][coachIndex].teams.push(team);
            this.setState({ team: this.state.team });
            this.addTeamCoach(coach, team, (key === "coaches") ? "coach" : "assCoach")
        }
    }

    addTeamCoach(coach, team, key) {
        this.state.team[this.state.currentView].designations.forEach((item, i) => {
            if (item.age === team.age && item.entry === team.entry && (item.gender === this.state.currentView)) {
                item[key] = coach;
                item[key + "Err"] = false;
                this.setState({ team: this.state.team });
            }
        })
    }

    removeTeamCoach(team, key) {
        this.state.team[this.state.currentView].designations.forEach((item, i) => {
            if (item.age === team.age && item.entry === team.entry && (item.gender === this.state.currentView)) {
                item[key] = { id: null, name: "" }
                item[key + "Err"] = true;
                this.setState({ team: this.state.team });
            }
        })
    }

    removeTeamFromCoach(team) {
        const coaches = this.state.team.coaches[this.state.currentView];
        const assCoaches = this.state.team.assCoaches[this.state.currentView];
        for (let i = 0; i < coaches.length; i++) {
            const coach = coaches[i];
            coach.teams.forEach((item, x) => {
                if (item.age === team.age && item.entry === team.entry && (item.gender === this.state.currentView)) {
                    this.state.team.coaches[this.state.currentView][i].teams.splice(x, 1);
                    this.setState({ team: this.state.team });
                }
            })
        }

        for (let i = 0; i < assCoaches.length; i++) {
            const coach = assCoaches[i];
            coach.teams.forEach((item, x) => {
                if (item.age === team.age && item.entry === team.entry && (item.gender === this.state.currentView)) {
                    this.state.team.assCoaches[this.state.currentView][i].teams.splice(x, 1);
                    this.setState({ team: this.state.team });
                }
            })
        }
    }

    onSave() {
        const team = this.state.team;
        const { requireExtraContent } = this.props
        if (requireExtraContent) {
            const _teams = this.getTeamNames();
            if (team.name === "" || FakeData.inArray(this.state.team.name.toLowerCase(),_teams)) {
                this.setState({ nameError: true });
                return;
            }

            if (team.level === "") {
                //this.setState({ levelErr: true });
                //return;
            }

            if (team.role === "") {
                this.setState({ roleErr: true });
                return;
            }
            //item.email === "" || !FakeData.isEmail(item.email)

            if (team.email === "" || !FakeData.isEmail(team.email)) {
                this.setState({ emailErr: true });
                return;
            }

            if (team.phone === "") {
                this.setState({ phoneErr: true });
                return;
            }

            if (team.land === "") {
                this.setState({ landErr: true });
                return;
            }

            if (team.website === "" || !FakeData.isWebsite(team.website)) {
                this.setState({ webErr: true });
                return;
            }
        }
        if (team.sport === "") {
            this.setState({ sportErr: true });
            return;
        }

        if (team.ground === "") {
            this.setState({ groundErr: true });
            return;
        }

        if (team.male.ages.length === 0 && team.female.ages.length === 0 && team.mixed.ages.length === 0) {
            this.setState({
                teamsErr: true
            });
            return;
        }

        if (requireExtraContent) {
            let malesBool = false;
            team.male.designations.forEach((item, i) => {
                if (item.coach.id === null) {
                    item.coachErr = true;
                    malesBool = true;
                }

                if (item.assCoach.id === null) {
                    item.assCoachErr = true;
                    malesBool = true;
                }

                this.setState({ team });
            })

            if (malesBool) {
                return;
            }

            let femalesBool = false;
            team.female.designations.forEach((item, i) => {
                if (item.coach.id === null) {
                    item.coachErr = true;
                    femalesBool = true;
                }

                if (item.assCoach.id === null) {
                    item.assCoachErr = true;
                    femalesBool = true;
                }

                this.setState({ team });
            })

            if (femalesBool) {
                return;
            }

            let mixedBool = false;
            team.mixed.designations.forEach((item, i) => {
                if (item.coach.id === null) {
                    item.coachErr = true;
                    mixedBool = true;
                }

                if (item.assCoach.id === null) {
                    item.assCoachErr = true;
                    mixedBool = true;
                }

                this.setState({ team });
            })

            if (mixedBool) {
                return;
            }
        }

        /*let malesBool = false;
        team.male.designations.forEach((item, i) => {
            if (item.coach.id === null) {
                item.coachErr = true;
                malesBool = true;
            }

            if (item.assCoach.id === null) {
                item.assCoachErr = true;
                malesBool = true;
            }

            this.setState({ team });
        })

        if (malesBool) {
            return;
        }

        let femalesBool = false;
        team.female.designations.forEach((item, i) => {
            if (item.coach.id === null) {
                item.coachErr = true;
                femalesBool = true;
            }

            if (item.assCoach.id === null) {
                item.assCoachErr = true;
                femalesBool = true;
            }

            this.setState({ team });
        })

        if (femalesBool) {
            return;
        }

        let mixedBool = false;
        team.mixed.designations.forEach((item, i) => {
            if (item.coach.id === null) {
                item.coachErr = true;
                mixedBool = true;
            }

            if (item.assCoach.id === null) {
                item.assCoachErr = true;
                mixedBool = true;
            }

            this.setState({ team });
        })

        if (mixedBool) {
            return;
        }*/

        if (requireExtraContent) {
            this.props.onClose(team, () => {
                this.setState({
                    team: {
                        male: {
                            ages: [],
                            designations: [],
                            assCoach: { name: "", id: null },
                            coach: { name: "", id: null },
                            hide: false
                        },
                        ground: "",
                        mixed: {
                            ages: [],
                            designations: [],
                            assCoach: { name: "", id: null },
                            coach: { name: "", id: null },
                            hide: false
                        },
                        female: {
                            ages: [],
                            designations: [],
                            assCoach: { name: "", id: null },
                            coach: { name: "", id: null },
                            hide: false
                        },
                        sport: "",
                        coaches: {
                            male: [{ name: "", id: null, teams: [], key: "male" }],
                            female: [{ name: "", id: null, teams: [], key: "female" }],
                            mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                        },
                        assCoaches: {
                            male: [{ name: "", id: null, teams: [], key: "male" }],
                            female: [{ name: "", id: null, teams: [], key: "female" }],
                            mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                        }
                    }
                });
            })
        } else {
            this.props.onClose(team)
            this.setState({
                team: {
                    male: {
                        ages: [],
                        designations: [],
                        assCoach: { name: "", id: null },
                        coach: { name: "", id: null },
                        hide: false
                    },
                    ground: "",
                    mixed: {
                        ages: [],
                        designations: [],
                        assCoach: { name: "", id: null },
                        coach: { name: "", id: null },
                        hide: false
                    },
                    female: {
                        ages: [],
                        designations: [],
                        assCoach: { name: "", id: null },
                        coach: { name: "", id: null },
                        hide: false
                    },
                    sport: "",
                    coaches: {
                        male: [{ name: "", id: null, teams: [], key: "male" }],
                        female: [{ name: "", id: null, teams: [], key: "female" }],
                        mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                    },
                    assCoaches: {
                        male: [{ name: "", id: null, teams: [], key: "male" }],
                        female: [{ name: "", id: null, teams: [], key: "female" }],
                        mixed: [{ name: "", id: null, teams: [], key: "mixed" }]
                    }
                }
            });
        }
    }

    getTeamsWithoutCoach() {
        const list = []
        const team = this.state.team[this.state.currentView];

        team.designations.forEach((item, i) => {
            if (item.coach.id === null) {
                list.push(item)
            }
        })

        return list;
    }

    getTeamsWithoutAssCoach() {
        const list = []
        const team = this.state.team[this.state.currentView];

        team.designations.forEach((item, i) => {
            if (item.assCoach.id === null) {
                list.push(item)
            }
        })

        return list;
    }

    updateTeamsCoach(coach, teams, key) {
        if (!coach.teams) {
            return;
        }
        setTimeout(() => {
            for (let i = 0; i < teams.length; i++) {
                const team = coach.teams[i];
                const coachFor = coach;
                this.state.team[this.state.currentView].designations.forEach((item, x) => {
                    if (item.age === team.age && item.entry === team.entry && (item.gender === this.state.currentView)) {
                        item[key] = coachFor;
                        this.setState({ team: this.state.team });
                    }
                })
            }
        }, 1000)
    }

    removeTeamsCoach(coach, key) {
        for (let i = 0; i < coach.teams.length; i++) {
            const team = coach.teams[i];
            const coachFor = coach;
            this.state.team[this.state.currentView].designations.forEach((item, x) => {
                if (item.age === team.age && item.entry === team.entry && (item.gender === this.state.currentView)) {
                    item[key] = { id: null, name: "" };
                    item[key + "Err"] = true;
                    this.setState({ team: this.state.team });
                }
            })
        }
    }

    onPhoneChange(num, err) {
        this.state.team.phone = num
        this.setState({ team: this.state.team, phoneErr: err });
    }

    onLandlineChange(num, err) {
        this.state.team.land = num
        this.setState({ team: this.state.team, landErr: err });
    }

    render() {
        const { requireExtraContent } = this.props
        const { team, isSearching } = this.state
        const _teams = this.getTeamNames();
        const arr = ["Amatuer", "Professional", "Semi-Professional"];
        const roles = ["Captain", "Coach", "Manager", "Player", "Referee", "Staff"];
        this.state.team[this.state.currentView].designations.sort(function (a, b) {
            var nameA = a.age.toUpperCase();
            var nameB = b.age.toUpperCase();
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            // names must be equal
            return 0;
        })
        if (requireExtraContent) {
            return (
                <Modal isOpen={this.props.isOpen} onClose={this.onClose.bind(this)}>
                    <div className="add-place" style={{ width: "700px" }}>
                        <h1>Add Teams</h1>
                        <h4 style={{ cursor: "pointer", color: (!isSearching) ? "#aaa" : "#CCC", paddingBottom: "5px", borderBottom: "none", position: "relative" }} onClick={() => this.setState({ isSearching: (isSearching) ? false : true })}>
                            Search team
                            <i className="material-icons" style={{ fontSize: "14px", position: "absolute", right: 0, marginTop: "10px", marginRight: "10px" }}>{(isSearching) ? "add" : "remove"}</i>
                        </h4>
                        {!isSearching &&
                            <ClubInvites fromId={this.props.contentId} fromType={this.props.contentType} isEmbedded={true} callback={this.onClose.bind(this)} />
                        }
                        <hr />
                        <h4 style={{ cursor: "pointer", color: (isSearching) ? "#aaa" : "#CCC", paddingBottom: "5px", borderBottom: "none", position: "relative" }} onClick={() => this.setState({ isSearching: (isSearching) ? false : true })}>
                            Add New Team
                            <i className="material-icons" style={{ fontSize: "14px", position: "absolute", right: 0, marginTop: "10px", marginRight: "10px" }}>{(!isSearching) ? "add" : "remove"}</i>
                        </h4>
                        {isSearching &&
                            <div style={{ width: "100%" }}>
                                {requireExtraContent &&
                                    <div className="add-team-with-input">
                                        <span>Name</span>
                                        <div className="add-team-with-input-fields">
                                            <input value={team.name} className={(this.state.nameError) ? "error" : FakeData.inArray(this.state.team.name.toLowerCase(),_teams)?"error": ""} onChange={(e) => {
                                                const val = e.target.value
                                                team.name = val;
                                                this.setState({ team, nameError: FakeData.inArray(this.state.team.name.toLowerCase(),_teams)?true:false });
                                            }} />
                                        </div>
                                    </div>
                                }
                                {/*requireExtraContent &&
                            <div className="add-team-with-input">
                                <span>Team professional level?</span>
                                <div className="add-team-with-input-fields">
                                    <select className={(this.state.levelErr) ? "error" : ""} value={this.state.team.level} onChange={(e) => {
                                        this.state.team.level = e.target.value
                                        this.setState({ team: this.state.team, levelErr: false });
                                    }}>
                                        <option value={""}>Select level</option>
                                        {
                                            arr.map((item, i) => {
                                                return (
                                                    <option key={i} value={item}>{item}</option>
                                                )
                                            })
                                        }
                                    </select>
                                </div>
                            </div>*/
                                }
                                {requireExtraContent &&
                                    <div className="add-team-with-input">
                                        <span>Your role?</span>
                                        <div className="add-team-with-input-fields">
                                            <select className={(this.state.roleErr) ? "error" : ""} value={this.state.team.role} onChange={(e) => {
                                                this.state.team.role = e.target.value
                                                this.setState({ team: this.state.team, roleErr: false });
                                            }}>
                                                <option value={""}>Select your role in the team</option>
                                                {
                                                    roles.map((item, i) => {
                                                        return (
                                                            <option key={i} value={item}>{item}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                }
                                {requireExtraContent &&
                                    <div className="add-team-with-input">
                                        <span>Email</span>
                                        <div className="add-team-with-input-fields">
                                            <input value={team.email} className={(this.state.emailErr) ? "error" : ""} onChange={(e) => {
                                                const val = e.target.value
                                                team.email = val;
                                                this.setState({ team, emailErr: (!FakeData.isEmail(val)) });
                                            }} />
                                        </div>
                                    </div>
                                }
                                {requireExtraContent &&
                                    <div className="add-team-with-input">
                                        <span>Phone</span>
                                        <div className="add-team-with-input-fields">
                                            <PhonePicker className={(this.state.phoneErr) ? "error" : ""} value={""} onChange={this.onPhoneChange.bind(this)} />
                                        </div>
                                    </div>
                                }
                                {requireExtraContent &&
                                    <div className="add-team-with-input">
                                        <span>Telephone</span>
                                        <div className="add-team-with-input-fields">
                                            <PhonePicker className={(this.state.landErr) ? "error" : ""} value={""} onChange={this.onLandlineChange.bind(this)} />
                                        </div>
                                    </div>
                                }
                                {requireExtraContent &&
                                    <div className="add-team-with-input">
                                        <span>Website</span>
                                        <div className="add-team-with-input-fields">
                                            <input value={team.website} className={(this.state.webErr) ? "error" : ""} onChange={(e) => {
                                                const val = e.target.value
                                                team.website = val;
                                                this.setState({ team, webErr: !FakeData.isWebsite(val) });
                                            }} />
                                        </div>
                                    </div>
                                }
                                <div className="add-team-with-input">
                                    <span>Sport</span>
                                    <div className="add-team-with-input-fields">
                                        <select className={(this.state.sportErr) ? "error" : ""} value={this.state.team.sport} onChange={(e) => {
                                            this.state.team.sport = e.target.value
                                            this.setState({ team: this.state.team, sportErr: false });
                                        }}>
                                            <option value={""}>Select Sport</option>
                                            {this.props.sports &&
                                                this.props.sports.map((item, i) => {
                                                    return (
                                                        <option key={i} value={item.name}>{item.name}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="add-team-with-input">
                                    <span>{(this.props.isClub) ? "Home ground" : "Campus"}</span>
                                    <div className="add-team-with-input-fields">
                                        <LocationPicker classes={(this.state.groundErr) ? "add-team-with-input-fields-location-pk error" : "add-team-with-input-fields-location-pk"} value={this.state.team.ground} user={FakeData.getData("yoo")} places={(FakeData.getData("yoo") && FakeData.getData("yoo").placesLived) ? FakeData.getData("yoo").placesLived.others : []} onSetPlace={(data) => {
                                            this.state.team.ground = data
                                            this.setState({
                                                team: this.state.team,
                                                groundErr: false
                                            });
                                        }} />
                                    </div>
                                </div>
                                <div className="add-team-with-input">
                                    <span>Gender</span>
                                    <div className="add-team-with-input-fields">
                                        <div className="add-team-with--radio-input-fields">
                                            {
                                                this.state.genders.map((item, i) => {
                                                    return (
                                                        <div key={i} onClick={() => {
                                                            this.state.team[item.toLowerCase()].hide = false
                                                            this.setState({ currentView: item.toLowerCase(), team: this.state.team });
                                                        }} >
                                                            <input readOnly type="radio" name="gender" checked={(this.state.currentView === item.toLowerCase())} value={item.toLowerCase()} />
                                                            <label>{item}</label>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="add-team-with-input">
                                    <span>Age Group</span>
                                    <div className="add-team-with-input-fields">
                                        <MultipleSelect className={(this.state.teamsErr) ? "error" : ""} addToDesignation={this.addToDesignation.bind(this)} removeFromDesignation={this.removeFromDesignation.bind(this)} label="Select a single or multiple age groups" keyOf={this.state.currentView} withData={true} valueData={this.state.team[this.state.currentView].ages} data={this.getAges()} onChange={(arr) => {
                                            this.state.team[this.state.currentView].ages = arr;
                                            this.setState({ team: this.state.team });
                                        }} />
                                    </div>
                                </div>
                                <div className="add-team-with-input">
                                    <span>Team Designations</span>
                                    <div className="add-team-with-input-fields">
                                        <div className="add-team-with-designation-input-fields">
                                            {this.state.team[this.state.currentView].designations.length > 0 &&
                                                <div className="add-team-with-designation-input-items">
                                                    {
                                                        this.state.team[this.state.currentView].designations.map((item, i) => {
                                                            if (item.entry !== 1) {
                                                                return null;
                                                            }
                                                            return (
                                                                <TeamField addToDesignation={this.addToDesignation.bind(this)} removeFromDesignation={this.removeFromDesignation.bind(this)} removeItemAt={(pos, team) => {
                                                                    this.removeTeamFromCoach(team)
                                                                    this.state.team[this.state.currentView].designations.splice(pos, 1);
                                                                    this.setState({
                                                                        team: this.state.team
                                                                    });
                                                                }} key={i} item={item} team={this.state.team[this.state.currentView]} saveTeam={(data) => {
                                                                    this.state.team[this.state.currentView] = data
                                                                    this.setState({
                                                                        team: this.state.team
                                                                    });
                                                                }} saveItem={(data) => {
                                                                    item = data
                                                                    this.setState({
                                                                        team: this.state.team
                                                                    });
                                                                }} />
                                                            )
                                                        })
                                                    }
                                                </div>
                                            }
                                            {(this.state.team[this.state.currentView].designations.length === 0) &&
                                                <div className="add-team-with-designation-input-add">
                                                    No age group(s) selected
                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                {this.withManager &&
                                    <div className="add-team-with-input">
                                        <span>Manager</span>
                                        <div className="add-team-with-input-fields">
                                            {this.state.currentView === "male" &&
                                                <ItemPicker value={this.state.team.male.manager.name} user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={(user) => {
                                                    this.state.team.male.manager = user;
                                                    this.setState({ team: this.state.team });
                                                }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                                            }
                                            {this.state.currentView === "female" &&
                                                <ItemPicker value={this.state.team.female.manager.name} user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={(user) => {
                                                    this.state.team.female.manager = user;
                                                    this.setState({ team: this.state.team });
                                                }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                                            }
                                            {this.state.currentView === "mixed" &&
                                                <ItemPicker value={this.state.team.mixed.manager.name} user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={(user) => {
                                                    this.state.team.mixed.manager = user;
                                                    this.setState({ team: this.state.team });
                                                }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                                            }
                                        </div>
                                    </div>
                                }
                                {this.state.team[this.state.currentView].designations.length > 0 &&
                                    this.state.team.coaches[this.state.currentView].map((item, i) => {
                                        return (
                                            <div key={item.key + i} className="add-team-with-input">
                                                <span>Coach {(this.state.team.coaches[this.state.currentView].length > 1) ? "#" + (i + 1) : ""}</span>
                                                <CoachPickerField propKEy="coaches" keyFor={this.state.currentView} canDelete={(this.state.team.coaches[this.state.currentView].length === 1) ? false : true} team={this.state.team[this.state.currentView]} coach={item} index={i} availables={this.getTeamsWithoutCoach()} updateCoach={(coach, index, teams) => {
                                                    const data = coach;
                                                    //data.teams = this.state.team.coaches[this.state.currentView][index].teams;
                                                    this.state.team.coaches[this.state.currentView][index] = data;
                                                    this.setState({ team: this.state.team });
                                                    this.updateTeamsCoach(data, teams, "coach")
                                                }} addCoach={this.addCoach.bind(this)} deleteCoach={(c, i) => {
                                                    if (this.state.team.coaches[this.state.currentView].length === 1) {
                                                        return;
                                                    }
                                                    this.state.team.coaches[this.state.currentView].splice(i, 1);
                                                    this.setState({ team: this.state.team });
                                                    this.removeTeamsCoach(c, "coach")
                                                }} />
                                            </div>
                                        )
                                    })
                                }
                                {this.getTeamsWithoutCoach().length > 0 &&
                                    <div className="add_new_coach" onClick={() => {
                                        if (this.getTeamsWithoutCoach().length === 0) {
                                            return
                                        }
                                        this.state.team.coaches[this.state.currentView].push({ name: "", id: null, teams: [], key: this.state.currentView })
                                        this.setState({ team: this.state.team });
                                    }}><i className="material-icons">add</i> Add another coach</div>
                                }

                                {this.state.team[this.state.currentView].designations.length > 0 &&
                                    this.state.team.assCoaches[this.state.currentView].map((item, i) => {
                                        return (
                                            <div key={item.key + i} className="add-team-with-input">
                                                <span>Ass. Coach {(this.state.team.assCoaches[this.state.currentView].length > 1) ? "#" + (i + 1) : ""}</span>
                                                <CoachPickerField propKEy="assCoaches" keyFor={this.state.currentView} canDelete={(this.state.team.assCoaches[this.state.currentView].length === 1) ? false : true} team={this.state.team[this.state.currentView]} coach={item} index={i} availables={this.getTeamsWithoutAssCoach()} updateCoach={(coach, index, teams) => {
                                                    const data = coach;
                                                    //data.teams = this.state.team.coaches[this.state.currentView][index].teams;
                                                    this.state.team.assCoaches[this.state.currentView][index] = data;
                                                    this.setState({ team: this.state.team });
                                                    this.updateTeamsCoach(data, teams, "assCoach")
                                                }} addCoach={this.addCoach.bind(this)} deleteCoach={(c, i) => {
                                                    if (this.state.team.assCoaches[this.state.currentView].length === 1) {
                                                        return;
                                                    }
                                                    this.state.team.assCoaches[this.state.currentView].splice(i, 1);
                                                    this.setState({ team: this.state.team });
                                                    this.removeTeamsCoach(c, "assCoach")
                                                }} />
                                            </div>
                                        )
                                    })
                                }
                                {this.getTeamsWithoutAssCoach().length > 0 &&
                                    <div className="add_new_coach" onClick={() => {
                                        if (this.getTeamsWithoutAssCoach().length === 0) {
                                            return
                                        }
                                        this.state.team.assCoaches[this.state.currentView].push({ name: "", id: null, teams: [], key: this.state.currentView })
                                        this.setState({ team: this.state.team });
                                    }}><i className="material-icons">add</i> Add another coach</div>
                                }
                            </div>
                        }
                        {isSearching &&
                            <button onClick={this.onSave.bind(this)}>Add Teams</button>
                        }
                    </div>
                </Modal>
            )
        }
        return (
            <Modal isOpen={this.props.isOpen} onClose={this.onClose.bind(this)}>
                <div className="add-place" style={{ width: "700px" }}>
                    <h1>Add Teams</h1>

                    <div style={{ width: "100%" }}>

                        <div className="add-team-with-input">
                            <span>Sport</span>
                            <div className="add-team-with-input-fields">
                                <select className={(this.state.sportErr) ? "error" : ""} value={this.state.team.sport} onChange={(e) => {
                                    this.state.team.sport = e.target.value
                                    this.setState({ team: this.state.team, sportErr: false });
                                }}>
                                    <option value={""}>Select Sport</option>
                                    {this.props.sports &&
                                        this.props.sports.map((item, i) => {
                                            return (
                                                <option key={i} value={item.name}>{item.name}</option>
                                            )
                                        })
                                    }
                                </select>
                            </div>
                        </div>
                        <div className="add-team-with-input">
                            <span>{(this.props.isClub) ? "Home ground" : "Campus"}</span>
                            <div className="add-team-with-input-fields">
                                <LocationPicker classes={(this.state.groundErr) ? "add-team-with-input-fields-location-pk error" : "add-team-with-input-fields-location-pk"} value={this.state.team.ground} user={FakeData.getData("yoo")} places={(FakeData.getData("yoo") && FakeData.getData("yoo").placesLived) ? FakeData.getData("yoo").placesLived.others : []} onSetPlace={(data) => {
                                    this.state.team.ground = data
                                    this.setState({
                                        team: this.state.team,
                                        groundErr: false
                                    });
                                }} />
                            </div>
                        </div>
                        <div className="add-team-with-input">
                            <span>Gender</span>
                            <div className="add-team-with-input-fields">
                                <div className="add-team-with--radio-input-fields">
                                    {
                                        this.state.genders.map((item, i) => {
                                            return (
                                                <div key={i} onClick={() => {
                                                    this.state.team[item.toLowerCase()].hide = false
                                                    this.setState({ currentView: item.toLowerCase(), team: this.state.team });
                                                }} >
                                                    <input readOnly type="radio" name="gender" checked={(this.state.currentView === item.toLowerCase())} value={item.toLowerCase()} />
                                                    <label>{item}</label>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="add-team-with-input">
                            <span>Age Group</span>
                            <div className="add-team-with-input-fields">
                                <MultipleSelect className={(this.state.teamsErr) ? "error" : ""} addToDesignation={this.addToDesignation.bind(this)} removeFromDesignation={this.removeFromDesignation.bind(this)} label="Select a single or multiple age groups" keyOf={this.state.currentView} withData={true} valueData={this.state.team[this.state.currentView].ages} data={this.getAges()} onChange={(arr) => {
                                    this.state.team[this.state.currentView].ages = arr;
                                    this.setState({ team: this.state.team });
                                }} />
                            </div>
                        </div>
                        <div className="add-team-with-input">
                            <span>Team Designations</span>
                            <div className="add-team-with-input-fields">
                                <div className="add-team-with-designation-input-fields">
                                    {this.state.team[this.state.currentView].designations.length > 0 &&
                                        <div className="add-team-with-designation-input-items">
                                            {
                                                this.state.team[this.state.currentView].designations.map((item, i) => {
                                                    if (item.entry !== 1) {
                                                        return null;
                                                    }
                                                    return (
                                                        <TeamField addToDesignation={this.addToDesignation.bind(this)} removeFromDesignation={this.removeFromDesignation.bind(this)} removeItemAt={(pos, team) => {
                                                            this.removeTeamFromCoach(team)
                                                            this.state.team[this.state.currentView].designations.splice(pos, 1);
                                                            this.setState({
                                                                team: this.state.team
                                                            });
                                                        }} key={i} item={item} team={this.state.team[this.state.currentView]} saveTeam={(data) => {
                                                            this.state.team[this.state.currentView] = data
                                                            this.setState({
                                                                team: this.state.team
                                                            });
                                                        }} saveItem={(data) => {
                                                            item = data
                                                            this.setState({
                                                                team: this.state.team
                                                            });
                                                        }} />
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    {(this.state.team[this.state.currentView].designations.length === 0) &&
                                        <div className="add-team-with-designation-input-add">
                                            No age group(s) selected
                                    </div>
                                    }
                                </div>
                            </div>
                        </div>
                        {this.withManager &&
                            <div className="add-team-with-input">
                                <span>Manager</span>
                                <div className="add-team-with-input-fields">
                                    {this.state.currentView === "male" &&
                                        <ItemPicker value={this.state.team.male.manager.name} user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={(user) => {
                                            this.state.team.male.manager = user;
                                            this.setState({ team: this.state.team });
                                        }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                                    }
                                    {this.state.currentView === "female" &&
                                        <ItemPicker value={this.state.team.female.manager.name} user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={(user) => {
                                            this.state.team.female.manager = user;
                                            this.setState({ team: this.state.team });
                                        }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                                    }
                                    {this.state.currentView === "mixed" &&
                                        <ItemPicker value={this.state.team.mixed.manager.name} user={FakeData.getData("yoo")} error={this.state.userError} onSelectedItem={(user) => {
                                            this.state.team.mixed.manager = user;
                                            this.setState({ team: this.state.team });
                                        }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                                    }
                                </div>
                            </div>
                        }
                        {this.state.team[this.state.currentView].designations.length > 0 &&
                            this.state.team.coaches[this.state.currentView].map((item, i) => {
                                return (
                                    <div key={item.key + i} className="add-team-with-input">
                                        <span>Coach {(this.state.team.coaches[this.state.currentView].length > 1) ? "#" + (i + 1) : ""}</span>
                                        <CoachPickerField propKEy="coaches" keyFor={this.state.currentView} canDelete={(this.state.team.coaches[this.state.currentView].length === 1) ? false : true} team={this.state.team[this.state.currentView]} coach={item} index={i} availables={this.getTeamsWithoutCoach()} updateCoach={(coach, index, teams) => {
                                            const data = coach;
                                            //data.teams = this.state.team.coaches[this.state.currentView][index].teams;
                                            this.state.team.coaches[this.state.currentView][index] = data;
                                            this.setState({ team: this.state.team });
                                            this.updateTeamsCoach(data, teams, "coach")
                                        }} addCoach={this.addCoach.bind(this)} deleteCoach={(c, i) => {
                                            if (this.state.team.coaches[this.state.currentView].length === 1) {
                                                return;
                                            }
                                            this.state.team.coaches[this.state.currentView].splice(i, 1);
                                            this.setState({ team: this.state.team });
                                            this.removeTeamsCoach(c, "coach")
                                        }} />
                                    </div>
                                )
                            })
                        }
                        {this.getTeamsWithoutCoach().length > 0 &&
                            <div className="add_new_coach" onClick={() => {
                                if (this.getTeamsWithoutCoach().length === 0) {
                                    return
                                }
                                this.state.team.coaches[this.state.currentView].push({ name: "", id: null, teams: [], key: this.state.currentView })
                                this.setState({ team: this.state.team });
                            }}><i className="material-icons">add</i> Add another coach</div>
                        }

                        {this.state.team[this.state.currentView].designations.length > 0 &&
                            this.state.team.assCoaches[this.state.currentView].map((item, i) => {
                                return (
                                    <div key={item.key + i} className="add-team-with-input">
                                        <span>Ass. Coach {(this.state.team.assCoaches[this.state.currentView].length > 1) ? "#" + (i + 1) : ""}</span>
                                        <CoachPickerField propKEy="assCoaches" keyFor={this.state.currentView} canDelete={(this.state.team.assCoaches[this.state.currentView].length === 1) ? false : true} team={this.state.team[this.state.currentView]} coach={item} index={i} availables={this.getTeamsWithoutAssCoach()} updateCoach={(coach, index, teams) => {
                                            const data = coach;
                                            //data.teams = this.state.team.coaches[this.state.currentView][index].teams;
                                            this.state.team.assCoaches[this.state.currentView][index] = data;
                                            this.setState({ team: this.state.team });
                                            this.updateTeamsCoach(data, teams, "assCoach")
                                        }} addCoach={this.addCoach.bind(this)} deleteCoach={(c, i) => {
                                            if (this.state.team.assCoaches[this.state.currentView].length === 1) {
                                                return;
                                            }
                                            this.state.team.assCoaches[this.state.currentView].splice(i, 1);
                                            this.setState({ team: this.state.team });
                                            this.removeTeamsCoach(c, "assCoach")
                                        }} />
                                    </div>
                                )
                            })
                        }
                        {this.getTeamsWithoutAssCoach().length > 0 &&
                            <div className="add_new_coach" onClick={() => {
                                if (this.getTeamsWithoutAssCoach().length === 0) {
                                    return
                                }
                                this.state.team.assCoaches[this.state.currentView].push({ name: "", id: null, teams: [], key: this.state.currentView })
                                this.setState({ team: this.state.team });
                            }}><i className="material-icons">add</i> Add another coach</div>
                        }
                    </div>
                    <button onClick={this.onSave.bind(this)}>Add Teams</button>
                </div>
            </Modal>
        );
    }
}

export class MultipleSelect extends Component {
    constructor(p) {
        super(p)
        this.state = {
            items: this.props.valueData,
            isActive: false,
            key: this.props.keyOf
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.key !== nextProps.keyOf) {
            this.setState({ items: nextProps.valueData, key: nextProps.keyOf });
        } else if (nextProps.valueData !== this.state.items.length) {
            this.setState({ items: nextProps.valueData });
        }
    }


    onSelect(item) {
        if (this.state.items.indexOf(item) > -1) {
            this.state.items.splice(this.state.items.indexOf(item), 1)
            this.props.removeFromDesignation(item, false)
            this.setState({ item: this.state.items });
        } else {
            this.state.items.push(item)
            this.setState({ item: this.state.items });
            this.props.addToDesignation(item)
        }

        this.props.onChange(this.state.items)
    }

    render() {
        return (
            <div className="multi-select" tabIndex={0} onBlur={() => this.setState({ isActive: false })}>
                <div className={"multi-select-btn " + this.props.className}>
                    {this.state.items.length > 0 &&
                        <div className="multi-select-btn-chips">
                            {
                                this.state.items.map((item, i) => {
                                    return (
                                        <span key={i} className="multi-select-btn-chip"><span>{item}</span> <i className="material-icons" onClick={() => this.onSelect(item)}>close</i></span>
                                    )
                                })
                            }
                        </div>
                    }
                    {this.state.items.length === 0 &&
                        <span className="multi-select-btn-holder" onClick={() => this.setState({ isActive: (this.state.isActive) ? false : true })}>{this.props.label ? this.props.label : "Select Items"}</span>
                    }
                    <span className="multi-select-btn-toggle" onClick={() => this.setState({ isActive: (this.state.isActive) ? false : true })}></span>
                </div>
                {this.state.isActive &&
                    <div className="multi-select-items">
                        {
                            this.props.data.map((item, i) => {
                                return (
                                    <span className={(this.state.items.indexOf(item) > -1) ? "selected" : ""} key={i} onClick={() => this.onSelect(item)}>{item}</span>
                                )
                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

export class TeamField extends Component {
    constructor(p) {
        super(p)
        this.state = {
            isShown: false
        }
    }

    getItems(arr, key) {
        const list = []
        arr.forEach((item, i) => {
            if (item.age === key) {
                list.push(item)
            }
        })

        return list;
    }

    render() {
        const item = this.props.item
        const count = this.getItems(this.props.team.designations, item.age).length
        return (
            <div className="add-team-with-designation-input-item-holder">
                <div className="add-team-with-designation-input-item">
                    <div className="add-more">
                        <span>{item.age}</span>
                        {count === 1 &&
                            <i className="material-icons" onClick={() => {
                                this.props.removeFromDesignation(item.age, true)
                            }}>delete</i>
                        }
                        {count > 1 &&
                            <i className="material-icons" onClick={() => {
                                this.setState({ isShown: (this.state.isShown) ? false : true });
                            }}>{(this.state.isShown) ? "visibility_off" : "visibility"}</i>
                        }
                    </div>
                    <div className={(item.coachErr || item.assCoachErr) ? "add-more with-error" : "add-more"} data-error={(item.coachErr && item.assCoachErr) ? "Add team coach & ass. coach" : ((item.coachErr && !item.assCoachErr) ? "Add team coach" : (!item.coachErr && item.assCoachErr) ? "* Add team ass. coach" : "")}>
                        <span>{(!this.state.isShown && count > 1) ? count + " Teams" : "Team " + item.entry}</span>
                        <i className="material-icons" onClick={() => {
                            this.props.addToDesignation(item.age)
                            this.setState({ isShown: true });
                        }}>add</i>
                    </div>
                    <input placeholder="Team Nickname" value={item.name} onChange={(e) => {
                        const val = e.target.value;
                        item.name = val;
                        this.props.saveItem(item)
                    }} />
                </div>
                {this.state.isShown &&
                    this.props.team.designations.map((team, x) => {
                        if (team.age !== item.age || team.entry === 1) {
                            return null;
                        }
                        return (
                            <div key={x} className="add-team-with-designation-input-item">
                                <span style={{ borderColor: "#fff", color: "#fff" }}>{team.age}</span>
                                <div className={(item.coachErr || item.assCoachErr) ? "add-more with-error" : "add-more"} data-error={(item.coachErr && item.assCoachErr) ? "Add team coach & ass. coach" : ((item.coachErr && !item.assCoachErr) ? "Add team coach" : (!item.coachErr && item.assCoachErr) ? "* Add team ass. coach" : "")}>
                                    <span>Team {team.entry}</span>
                                    <i className="material-icons" onClick={() => {
                                        this.props.removeItemAt(x, team)
                                    }}>delete</i>
                                </div>
                                <input placeholder="Team Nickname" value={team.name} onChange={(e) => {
                                    const val = e.target.value;
                                    team.name = val;
                                    this.props.saveTeam(this.props.team)
                                }} />
                            </div>
                        )
                    })
                }
            </div>
        );
    }
}

export class CoachPickerField extends Component {
    constructor(p) {
        super(p)
        this.state = {
            isActive: false,
            teams: this.props.coach.teams
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.coach.id === null) {
            this.forceUpdate()
        }
    }

    render() {
        return (
            <div className="add-team-with-input-fields">
                <ItemPicker key={this.props.keyFor + this.props.index} id={this.props.keyFor + this.props.index} parentWidth={"48%"} value={this.props.coach.name} user={FakeData.getData("yoo")} error={this.props.userError} onSelectedItem={(user) => {
                    //team.coach = user;
                    user.teams = this.state.teams;
                    user.key = this.props.keyFor;
                    this.props.updateCoach(user, this.props.index, this.state.teams)
                }} width="27.85em" isExtended={true} data={FakeData.getData("yoo").friends} />
                <div className="add-team-with-coaches" tabIndex={0} onBlur={() => {
                    this.setState({ isActive: false });
                }}>
                    <div key={"_" + this.props.keyFor + this.props.index} id={"_" + this.props.keyFor + this.props.index} className="add-team-with-coaches-list">
                        <span>{(this.props.coach.teams.length === 0) ? "No teams selected" : (this.props.coach.teams.length === 1) ? this.props.coach.teams[0].age + " (Team " + this.props.coach.teams[0].entry + ")" : this.props.coach.teams.length + " teams"}</span>
                        {this.state.isActive &&
                            <div className="add-team-with-coaches-list-content">
                                {
                                    this.props.coach.teams.map((item, i) => {
                                        return (
                                            <span className="selected" key={i}><span>{item.age + " (Team " + item.entry + ")"}</span><i className="material-icons" onClick={() => {
                                                this.props.addCoach(this.props.coach, this.props.index, item, this.props.propKEy)
                                            }}>delete</i></span>
                                        )
                                    })
                                }
                                {
                                    this.props.availables.map((item, i) => {
                                        return (
                                            <span key={i}><span>{item.age + " (Team " + item.entry + ")"}</span><i className="material-icons" onClick={() => {
                                                this.props.addCoach(this.props.coach, this.props.index, item, this.props.propKEy)
                                            }}>add</i></span>
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                    <span onClick={() => this.setState({ isActive: (this.state.isActive) ? false : true })}></span>
                </div>
                {this.props.canDelete &&
                    <i className="material-icons" onClick={() => {
                        this.props.deleteCoach(this.props.coach, this.props.index)
                    }}>delete</i>
                }
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/pages/CreatePages/ClubInit.js